import { render, staticRenderFns } from "./mianzheng-add.vue?vue&type=template&id=5f4a1da3&scoped=true&"
import script from "./mianzheng-add.vue?vue&type=script&lang=js&"
export * from "./mianzheng-add.vue?vue&type=script&lang=js&"
import style0 from "./mianzheng-add.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mianzheng-add.vue?vue&type=style&index=1&id=5f4a1da3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a1da3",
  null
  
)

export default component.exports